import { feedbackQuestionSlice } from '../store/slices/feedbackSlice';

export const { setFeedbackQuestions: feedbackSessionQuestion } = feedbackQuestionSlice.actions;
